export const exhaustiveSwitchGuard = (
  value: never,
  shouldFail: boolean = true
): never | null => {
  if (shouldFail)
    throw new Error(
      `Not all possible cases were covered in this switch statement. Missed case: ${value}`
    );
  return null;
};
